import { useContext } from 'react';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';

export const useBudgetRange = () => {
  const serverContext = useContext(ServerContext) as any;
  const currencyCode = serverContext?.CurrentAccount?.CurrencyCode || 'USD';

  const minDailyBudget = serverContext?.BudgetRange?.DailyRange?.FloorValue;

  // Currently the max daily budget returned by server context is the same as max monthly budget https://msasg.visualstudio.com/Bing_Ads/_git/AdsAppUI?path=/private/UI/OpportunityUI/Microsoft.AdCenter.UI.Web.Opportunity/Repository/StaticEntityRepository.cs&version=GBmaster&line=86&lineEnd=86&lineStartColumn=13&lineEndColumn=122&lineStyle=plain&_a=contents
  // Because of that we use the same logic as on MT where maxDailyBudget = maxMonthlyBudget / 28 https://msasg.visualstudio.com/DefaultCollection/Bing_Ads/_git/AdsAppsMT?path=/private/Common/BusinessRules/CampaignValidators/BudgetLimitHelper.cs&version=GBmaster&line=10&lineEnd=12&lineStartColumn=1&lineEndColumn=35&lineStyle=plain&_a=contents
  const maxDailyBudget = serverContext?.BudgetRange?.MonthlyRange?.CeilingValue
    ? Number((serverContext.BudgetRange.MonthlyRange.CeilingValue / 28).toFixed(2))
    : serverContext?.BudgetRange?.DailyRange?.CeilingValue;

  return {
    currencyCode,
    minDailyBudget,
    maxDailyBudget,
  };
};
